import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Container, Row, Col } from "reactstrap";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class ProductInstantCheckout extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }
  _initForm = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const { ICbuttonColor, ICbuttonBgColor } = payload.datas || {
      ICbuttonLabel: null,
    };

    let ICbuttonLabel = (payload.datas && payload.datas["ICbuttonLabel"]) || "";

    if (
      payload.datas &&
      payload.datas["ICbuttonLabel_" + this.props.currentLang]
    )
      ICbuttonLabel = payload.datas["ICbuttonLabel_" + this.props.currentLang];

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "Paragraph");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol">
            <div
              className="container-fluid checkoutform"
              style={cssSettingsText}
            >
              <div className="overlay"></div>
              <div className="row lowerlay">
                <div className="col-md-12 fullcol">
                  <ul id="tabs" className="nav nav-tabs">
                    <li className="nav-item">
                      <a
                        href=""
                        data-target="#shipping-block"
                        data-toggle="tab"
                        className="nav-link small text-uppercase active"
                      >
                        <div className="num1">1</div>
                        <div className="title-txt">
                          SHIPPING <span>Where To Ship Your Item</span>
                        </div>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href=""
                        data-target="#billing-block"
                        data-toggle="tab"
                        className="nav-link small text-uppercase"
                      >
                        <div className="num1">2</div>
                        <div className="title-txt">
                          {" "}
                          YOUR INFO <span>Your Billing Info</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                  <div id="tabsContent" className="tab-content">
                    <div
                      id="shipping-block"
                      className="tab-pane fade active show"
                    >
                      <div className="form-row">
                        <div className="col-md-6">
                          <input type="text" placeholder="First Name..." />
                        </div>
                        <div className="col-md-6">
                          <input type="text" placeholder="Last Name..." />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <input type="text" placeholder="Email Address..." />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <input
                            type="text"
                            placeholder="Cell Phone Number..."
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12 heading-divider">
                          <span>SHIPPING</span>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <input type="text" placeholder="Full Address..." />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <input type="text" placeholder="City Name..." />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-8">
                          <select name="id_state" className="">
                            <option value="0">Select State</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <input type="text" placeholder="Zip Code..." />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <select name="id_country">
                            <option value="21">United States</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <button
                            className="submit-btn"
                            style={{
                              color: ICbuttonColor,
                              backgroundColor: ICbuttonBgColor,
                            }}
                          >
                            {ICbuttonLabel || "Add to cart"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initForm()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initForm()}
      </Draggable>
    );
  }
}

ProductInstantCheckout.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductInstantCheckout);
